import { useDispatch, useSelector } from 'react-redux';
import FJTranscribe from '../view/FJTranscribe.jsx';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';

const FJTranscribeContainer = props => {
    const dispatch = useDispatch();
    const activePanelName = useSelector(state => state.textBasedEditing.activePanelName);
    if (activePanelName !== 'transcribing') return;

    const _onCancel = () => {
        dispatch(FJActionTextBasedEditing.onCancelAction());
    };

    return <FJTranscribe onCancel={_onCancel} />;
};

export default FJTranscribeContainer;
